<template>
    <div class="m-schedule">
        <y-container>
            <y-row
                v-if="content && configs && configs.commenting_submit"
                class="ma-0"
            >
                <y-col
                    md="12"
                    lg="7"
                >
                    <div class="m-schedule__content-wrapper">
                        <y-row>
                            <y-col
                                size="12"
                                class="pa-0"
                            >
                                <h1
                                    class="title"
                                    v-html="titleGenerator(content.title)"
                                />
                            </y-col>
                            <y-col
                                size="12"
                                class="pa-0"
                            >
                                <p class="synopsis">
                                    {{ content.synopsis }}
                                </p>
                            </y-col>
                            <y-col
                                v-if="$mq === 'lg' || $mq === 'xlg'"
                                size="12"
                                class="pa-0"
                            >
                                <y-col
                                    size="12"
                                    class="pa-0"
                                >
                                    <h2
                                        class="title2 mt-0"
                                        v-html="titleGenerator(content.title2)"
                                    />
                                </y-col>
                            </y-col>
                            <y-col
                                v-if="$mq === 'lg' || $mq === 'xlg'"
                                size="12"
                                class="pa-0"
                            >
                                <y-row>
                                    <y-col
                                        v-for="(item, index) in content.albums"
                                        :key="`content-album-${index}`"
                                        md="12"
                                        lg="6"
                                    >
                                        <y-row>
                                            <y-col size="12">
                                                <img
                                                    class="album-img"
                                                    :src="item.link"
                                                    :alt="item.title"
                                                >
                                            </y-col>
                                            <y-col size="12">
                                                <h3 class="album-title">
                                                    {{ item.title }}
                                                </h3>
                                            </y-col>
                                            <y-col size="12">
                                                <p class="album-text mt-0 mb-8">
                                                    {{ item.description }}
                                                </p>
                                            </y-col>
                                        </y-row>
                                    </y-col>
                                </y-row>
                            </y-col>
                        </y-row>
                    </div>
                </y-col>
                <y-col
                    md="12"
                    lg="5"
                    class="m-schedule__form"
                >
                    <div class="m-schedule__fields-wrapper">
                        <div>
                            <div class="m-schedule__fields-wrapper__bg">
                                <div class="m-schedule__fields-wrapper__fields">
                                    <div
                                        v-if="configs.commenting_name !== 'no_receive'"
                                        class="mb-7"
                                    >
                                        <label
                                            class="form-label"
                                            :class="{'forced-data': configs.commenting_name === 'required'}"
                                            for="name"
                                        >
                                            {{ $t('schedule.full_name') }}
                                        </label>
                                        <y-input
                                            id="name"
                                            v-model="model.name"
                                            name="your_name"
                                            no-label
                                            :placeholder="$t('schedule.full_name')"
                                            class="mt-2"
                                        />
                                    </div>

                                    <div
                                        v-if="configs.commenting_email !== 'no_receive'"
                                        class="mb-7"
                                    >
                                        <label
                                            class="form-label"
                                            :class="{'forced-data': configs.commenting_email === 'required'}"
                                            for="email"
                                        >
                                            {{ $t('schedule.email_address') }}
                                        </label>
                                        <y-input
                                            id="email"
                                            v-model="model.email"
                                            no-label
                                            name="your_email"
                                            :placeholder="$t('schedule.email_address')"
                                            class="mt-2"
                                        />
                                    </div>

                                    <div
                                        v-if="configs.commenting_company_name !== 'no_receive'"
                                        class="mb-7"
                                    >
                                        <label
                                            class="form-label"
                                            :class="{'forced-data': configs.commenting_company_name === 'required'}"
                                            for="company"
                                        >
                                            {{ $t('fields.company_name') }}
                                        </label>
                                        <y-input
                                            id="company"
                                            v-model="model.company_name"
                                            name="company_name"
                                            no-label
                                            :placeholder="$t('fields.company_name')"
                                            class="mt-2"
                                        />
                                    </div>

                                    <div class="mb-7">
                                        <label
                                            class="form-label forced-data"
                                            for="select_service"
                                        >
                                            {{ $t('schedule.interested_service') }}
                                        </label>
                                        <y-select
                                            id="select_service"
                                            :options="interestedServices"
                                            no-label
                                            :placeholder="$t('schedule.select_service')"
                                            class="m-schedule__fields-wrapper__fields__select mt-2"
                                            @select="selectedService = $event"
                                        />
                                    </div>

                                    <div
                                        v-if="configs.commenting_attachment !== 'no_receive'"
                                        class="mb-7"
                                    >
                                        <label
                                            class="form-label"
                                            :class="{'forced-data': configs.commenting_attachment === 'required'}"
                                            for="uploader"
                                        >
                                            {{ $t('schedule.file') }}
                                        </label>
                                        <div
                                            class="uploader-content"
                                            @click="openUploader"
                                        >
                                            <img
                                                src="~@/assets/images/attach-icon.svg"
                                                alt=""
                                            >
                                            <span>
                                                {{ $t('schedule.uploader_content') }}
                                                <small>
                                                    {{ findRequestedFormat(configs.commenting_attachment_extensions) }}
                                                </small>
                                            </span>
                                        </div>
                                        <y-uploader
                                            id="uploader"
                                            ref="uploader"
                                            v-model="model.attachment"
                                            class="mt-2"
                                            name="attachment"
                                            :max-file-size="configs.commenting_attachment_max_capacity"
                                            :accepted-files="configs.commenting_attachment_extensions"
                                            :max-files="configs.commenting_attachment_max_number"
                                            :payload="configs.payload"
                                            linear
                                            color="primary"
                                        />
                                    </div>

                                    <div
                                        v-if="configs.commenting_text !== 'no_receive'"
                                        class="mb-7"
                                    >
                                        <label
                                            class="form-label"
                                            :class="{'forced-data': configs.commenting_text === 'required'}"
                                            for="textarea"
                                        >
                                            {{ $t('fields.message') }}
                                        </label>
                                        <y-textarea
                                            id="textarea"
                                            v-model="model.text"
                                            no-label
                                            name="message"
                                            class="mt-2"
                                            rows="5"
                                        />
                                    </div>

                                    <y-button
                                        id="submit-demo"
                                        flat
                                        color="primary"
                                        class="submit-button mt-7"
                                        block
                                        loading-on="saving-schedule-demo"
                                        :disabled="checkBtnStatus"
                                        @click="beforeSubmit"
                                    >
                                        {{ content.custom['button-title'] }}
                                    </y-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </y-col>
                <y-col
                    v-if="$mq !== 'lg' && $mq !== 'xlg'"
                    size="12"
                >
                    <div class="m-schedule__content-wrapper mt-5">
                        <y-row>
                            <y-col
                                size="12"
                                class="pa-0"
                            >
                                <y-col
                                    size="12"
                                    class="pa-0"
                                >
                                    <h2
                                        class="title2 mt-0"
                                        v-html="titleGenerator(content.title2)"
                                    />
                                </y-col>
                            </y-col>
                            <y-col
                                size="12"
                                class="pa-0"
                            >
                                <y-row>
                                    <y-col
                                        v-for="(item, index) in content.albums"
                                        :key="`content-album-${index}`"
                                        md="12"
                                        lg="6"
                                    >
                                        <y-row>
                                            <y-col size="12">
                                                <img
                                                    class="album-img"
                                                    :src="item.link"
                                                    :alt="item.title"
                                                >
                                            </y-col>
                                            <y-col size="12">
                                                <h3 class="album-title">
                                                    {{ item.title }}
                                                </h3>
                                            </y-col>
                                            <y-col size="12">
                                                <p class="album-text mt-0 mb-8">
                                                    {{ item.description }}
                                                </p>
                                            </y-col>
                                        </y-row>
                                    </y-col>
                                </y-row>
                            </y-col>
                        </y-row>
                    </div>
                </y-col>
            </y-row>
        </y-container>

        <y-recaptcha
            v-if="configs && configs.recaptcha"
            ref="recaptcha"
            :site-key="configs.recaptcha.key"
            :size="configs.recaptcha?.size"
            @verify="afterVerify"
        />

        <y-modal
            ref="calendlyModal"
            no-footer
            no-header
        >
            <div class="submit-modal">
                <img
                    src="~@/assets/images/submit-demo.svg"
                    alt="hero"
                    class="hero"
                >
                <p class="title">
                    {{ content?.custom?.field1 }}
                </p>
                <p class="text">
                    <img
                        src="~@/assets/images/spinner.gif"
                        alt="spinner"
                    >
                    {{ content?.custom?.field2 }}
                </p>
            </div>
        </y-modal>
    </div>
</template>

<script>
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import HelpersMixin from '@/mixins/helpers';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    // components
    import {
        YInput, YRecaptcha, YTextarea, YUploader, YSelect, YModal,
    } from '@groot-components/all';

    export default {

        name: 'ScheduleDemoPage',

        components: {
            YInput,
            YTextarea,
            YUploader,
            YRecaptcha,
            YSelect,
            YModal,
        },

        mixins: [PageMixin, HelpersMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                content           : '',
                configs           : null,
                model             : {},
                selectedService   : {},
                interestedServices: [],
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.content.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.content.seo_meta_description,
                    },
                ],
            };
        },

        computed: {
            /**
             * Check submit btn status
             *
             * @returns {boolean}
             */
            checkBtnStatus() {
                if (this.configs.commenting_name === 'required' && !this.model.name) {
                    return true;
                }
                if (this.configs.commenting_email === 'required' && !this.model.email) {
                    return true;
                }
                if (this.configs.commenting_company_name === 'required' && !this.model.company_name) {
                    return true;
                }
                if (this.configs.commenting_attachment === 'required' && !this.model.attachment) {
                    return true;
                }
                if (this.configs.commenting_text === 'required' && !this.model.text) {
                    return true;
                }
                return !this.selectedService.id;
            },
        },

        /**
         * @inheritdoc
         */
        created() {
            if (!this.$wait.is('fetch-schedule-demo')) {
                this.fetch();
            }
        },

        methods: {
            removeSymbol,

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * Open uploader
             */
            openUploader() {
                const uploader = document.getElementById('uploader');
                if (uploader) {
                    uploader.click();
                }
            },

            /**
             * Show email and find $ char for change COLOR
             *
             * @param {string} text
             * @returns {string}
             */
            emailLinkGenerator(text) {
                return text.replace(/\$(.*?)\$/g, '<a href="mailto:$1" class="color-primary">$1</a>');
            },
            /**
             * Find requested format and list it.
             *
             * @param {Array} extensions
             * @returns {string}
             */
            findRequestedFormat(extensions) {
                const formattedExtensions = extensions.map((ext, index) => (
                    index !== extensions.length - 1 ? `${ext},` : ext
                ));
                const maxCapacity = this.configs.commenting_attachment_max_capacity;
                return `(${formattedExtensions.join('').toUpperCase()}, Max Size ${maxCapacity}M)`;
            },

            /**
             * Fetch form config
             *
             * @returns {*}
             */
            fetch() {
                this.$wait.start('fetch-schedule-demo');
                const content = this.$services.Content.postSingle({
                    type     : 'pages',
                    slug     : 'schedule-demo',
                    including: [
                        'title',
                        'title2',
                        'synopsis',
                        'custom',
                        'albums',
                        'seo_canonical',
                        'seo_meta_description',
                        'seo_post_title',
                    ],
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const form = this.$services.Commenting.getFormConfig({
                    type  : 'pages',
                    slug  : 'schedule-demo',
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const selectList = this.$services.Content.postList({
                    type     : 'pages',
                    tagging  : 'demo',
                    including: [
                        'title',
                        'id',
                    ],
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([content, form, selectList]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.content = responses[0].data.results;
                    }
                    if (this.handleReq(responses, 1)) {
                        this.configs = {
                            ...responses[1].data.results,
                            recaptcha: responses[1].data.metadata.recaptcha,
                            payload  : responses[1].data.metadata.payload,
                        };
                    }
                    if (this.handleReq(responses, 2)) {
                        this.interestedServices = responses[2].data.results?.reverse().map((item) => ({ ...item, label: item.title }));
                        this.selectedService = this.interestedServices.length ? this.interestedServices[0] : {};
                    }
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('fetch-schedule-demo');
                });
            },

            /**
             * Verify recaptcha
             * Check recaptcha is active
             */
            beforeSubmit() {
                if (this.configs?.recaptcha?.active === '1') {
                    this.$refs.recaptcha.verify();
                } else {
                    this.save();
                }
            },

            /**
             * Set token and start Sending Comment
             *
             * @param {string} token
             */
            afterVerify(token) {
                this.model['g-recaptcha-response'] = token;
                this.save();
            },

            /**
             * Do send comment
             *
             * @returns {object}
             */
            save() {
                this.$wait.start('saving-schedule-demo');
                return this.$services.Commenting.commentSave({
                    ...this.model,
                    id: this.selectedService.id,
                }).then(() => {
                    this.model = {};
                    this.showSubmitModal();
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('saving-schedule-demo');
                    this.$refs.recaptcha?.reset();
                });
            },
            /**
             * Show submit modal and call candley
             */
            showSubmitModal() {
                this.$refs.calendlyModal.open();
                setTimeout(() => {
                    window.location.href = this.$settings('content.calendly-link');
                }, 2000);
            },
        },
    };
</script>

<style lang="scss" src="../scss/schedule.scss" />

